$(() => {
  $('[data-job-entry-contract]').on('change', function () {
    switchEntryButton(this.value);
  });

  const switchEntryButton = selectedVal => {
    if (selectedVal === undefined) {
      return false;
    }

    $('[data-needs-actions]').each(function () {
      $(this).addClass('d-none');
    });

    const $entryButtonLink = $('[data-go-to-entry]');

    if (selectedVal.length) {
      if ($(`[data-needs-actions=${selectedVal}]`).length) {
        $(`[data-needs-actions=${selectedVal}]`).removeClass('d-none');
        $entryButtonLink.hide();
      } else {
        $entryButtonLink.removeClass('disabled');
        $entryButtonLink.show();
      }
    } else {
      $entryButtonLink.addClass('disabled');
      $entryButtonLink.show();
    }
  };

  switchEntryButton($('[data-job-entry-contract]').val());
});
